import Masonry from "masonry-layout";

const executiveTeam = {
  init() {
    executiveTeam.create();
  },
  create() {
    if ($("[data-member]").length) {
      var grid = document.querySelector(".masonry-grid");
      var msnry = new Masonry(grid, {
        columnWidth: ".panel.panel-executive-team .thumbs .item",
        horizontalOrder: true,
        percentPosition: true,
        isOriginLeft: false,
      });

      $(document).on("click", "[data-thumb-member]", function () {
        const self = $(this);
        const idx = self.data("thumb-member");
        const eleP = self.closest("[data-executive-team]");
        const currentTotalThumbs = self
          .closest("[data-executive-team]")
          .find("[data-thumb-member]").length;
        const total = eleP.find("[data-member]").length;

        const eleCurrentMember = eleP.find(`[data-member].active`);
        const eleCurrentMemberPortrait = eleP.find(`[data-portrait].active`);
        const eleTargetMember = eleP.find(`[data-member="${idx}"]`);
        const eleTargetMemberPortrait = eleP.find(`[data-portrait="${idx}"]`);

        if (eleTargetMember.length) {
          $('.panel.panel-executive-team .member [data-bio]').stop().fadeOut();

          if (eleCurrentMember.length) {
            TweenMax.staggerTo(
              eleCurrentMember.find("[data-text]"),
              0.75,
              { opacity: 0 },
              0.15
            );
            TweenMax.to(eleCurrentMemberPortrait, 0.5, { opacity: 0 });

          }

          eleP.find("[data-member]").removeClass("active");
          eleTargetMember.addClass("active");
          eleP.find("[data-portrait]").removeClass("active");
          eleTargetMemberPortrait.addClass("active");

          TweenMax.set(eleTargetMember.find("[data-text]"), {
            opacity: 0,
          });
          TweenMax.staggerTo(
            eleTargetMember.find("[data-text]"),
            0.75,
            { opacity: 1, x: 0 },
            0.15
          );

          TweenMax.to(eleTargetMemberPortrait, 0.75, { opacity: 1 });

          msnry.remove(self);

          if (total - currentTotalThumbs === 1) {
            // Append
            var fragment = document.createDocumentFragment();
            var elem = document.createElement("div");
            elem.classList.add("item");
            elem.classList.add("item-appended");
            elem.setAttribute(
              "data-thumb-member",
              eleCurrentMember.data("member")
            );
            const img = document.createElement("img");
            img.src = eleCurrentMember.data("thumb-image");
            elem.appendChild(img);

            fragment.appendChild(elem);
            grid.appendChild(fragment);
            msnry.appended([elem]);
            // End of Append
          }
        }

        msnry.layout();
      });

      $("[data-thumb-member]").eq(0).trigger("click");

      $("[data-member-arrow]").on("click", function (e) {
        e.preventDefault();
        const self = $(this);
        const direction = self.data("member-arrow");
        const total = self
          .closest("[data-executive-team]")
          .find("[data-member]").length;
        const idxCurrentMember = parseInt(
          self
            .closest("[data-executive-team]")
            .find(`[data-member].active`)
            .data("member")
        );
        let targetMember;

        if (direction === "next") {
          targetMember =
            idxCurrentMember + 1 > total - 1 ? 0 : idxCurrentMember + 1;
        } else {
          targetMember =
            idxCurrentMember - 1 < 0 ? total - 1 : idxCurrentMember - 1;
        }

        self
          .closest("[data-executive-team]")
          .find(`[data-thumb-member="${targetMember}"]`)
          .trigger("click");
      });

      $("[data-view-bio]").on("click", function(e) {
        e.preventDefault();
        const self = $(this);
        self.closest("[data-member]").find("[data-bio]").stop().fadeIn();
      });

      $("[data-bio] [data-close-bio]").on("click", function() {
        const self = $(this);
        self.closest("[data-bio]").stop().fadeOut();
      });
    }
  },
};

$(function () {
  executiveTeam.init();
});
